import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { ErrorMessage, IsLoading } from '../../components/LoadingOrErrorCollection'
import { shouldRender } from '../../utils'
import { Collection } from '../Collection'
import { CollectionItem, Photo } from './theme'
import { InfoBox, InfoText } from "../Frame/theme";

const CollectionProductsSets = ({ isLoading, errMessage, photos = [], insert }) => (
  <Fragment>
    <IsLoading isLoading={isLoading} />
    <ErrorMessage errMessage={errMessage} />

    {shouldRender(errMessage, isLoading) && (
      <Collection>
        {photos.map(photo => (
          <CollectionItem key={`${photo.index}`} onClick={() => insert(photo.index)}>
            <Photo className={'loading-img'} src={photo.preview} alt={photo.alt} />
              <InfoBox>
                <InfoText>{photo.name}</InfoText>
              </InfoBox>
          </CollectionItem>
        ))}
      </Collection>
    )}
  </Fragment>
)

CollectionProductsSets.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  errMessage: PropTypes.string.isRequired,
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number.isRequired,
      sets: PropTypes.arrayOf(
        PropTypes.shape({
          width: PropTypes.number.isRequired,
          height: PropTypes.number.isRequired,
        })
      ),
      preview: PropTypes.string.isRequired,
    })
  ),
}

export default CollectionProductsSets



// WEBPACK FOOTER //
// ./src/components/CollectionProductsSets/index.js